<h1 class="page-title mb-5">القوانين واللوائح </h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
          <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
            الهيئة العامة للاستثمار والمناطق الحرة هي هيئة اقتصادية عامة لها شخصية اعتبارية عامة تنظم الاستثمار في
            الدولة وتشجعه وتدعمه وتديره وتروج له بما يحقق خطة التنمية الاقتصادية للدولة ، ولها أن تنشئ فروعاً لها. أو
            مكاتب داخل جمهورية مصر العربية أو في الخارج بقرار من مجلس الإدارة كجزء من بعثات التمثيل التجاري. ​​
          </p>
        </div>
        <ul class="links-nav-cont p-0 m-0" id="pills-tab" role="tablist">
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/RulesInvestmentsAndBusinessComponent'" title=" قوانين الاستثمار والأعمال
">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/businesslaws.jpg" title=" قوانين الاستثمار والأعمال
" alt=" قوانين الاستثمار والأعمال
" />
              </div>
              <span> قوانين الاستثمار والأعمال
              </span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/OrganizeRulesComponent'" title="المناطق الاستثمارية
">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/businesslaws1.jpg" title=" قوانين التنظيم والتجارة
" alt=" قوانين التنظيم والتجارة
" />
              </div>
              <span> قوانين التنظيم والتجارة
              </span>
            </a>
          </li>
          <li class="links-nav">
            <a class="link-nav-href" [routerLink]="'/MoneyRulesComponent'" title=" القوانين المالية
​​​​​​​​​​​​​​​​​​​​​​​​​​​​​​">
              <div class="img-wrapper">
                <img class="pill-img" src="../../../assets/businesslaws2.jpg" title=" القوانين المالية
​​​​​​​​​​​​​​​​​​​​​​​​​​​​​​" alt=" القوانين المالية
​​​​​​​​​​​​​​​​​​​​​​​​​​​​​​" />
              </div>
              <span> القوانين المالية
                ​​​​​​​​​​​​​​​​​​​​​​​​​​​​​​</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-3">
        <app-fixed-go-on></app-fixed-go-on>
      </div>
    </div>
  </div>
</div>